import { render, staticRenderFns } from "./InsCmsList.vue?vue&type=template&id=055bee15&scoped=true&"
import script from "./InsCmsList.vue?vue&type=script&lang=ts&"
export * from "./InsCmsList.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsList.vue?vue&type=style&index=0&id=055bee15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055bee15",
  null
  
)

export default component.exports